// removed by extract-text-webpack-plugin
module.exports = {"page":"kH2_-","album":"_2OPoY","thumb":"u8mZz","name":"_6DqMA","info":"_1Raxk","button":"jcmuH","editButton":"_23yvT"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/List.css
// module id = 858
// module chunks = 0